module.exports = __webpack_public_path__ + "static/pct-4982380a95be6c97cb5f21b93b1ec4a9.jpg";